import React from 'react';
import {DateTimeFormat} from 'components/UI/DateTime';

class MessageItem extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      message: this.props.message
    }
  }

  render() {
    return (
      <tbody>

        <tr>
          <td></td>
          <td>{this.props.message.user && this.props.message.user.fullname}</td>
          <td>
            <p className='item-comment-business-desc'>{this.props.message.content}</p>
          </td>
          <td>
            <p className='item-comment-business-desc'><DateTimeFormat value={this.props.message.createdAt}/></p>
          </td>
          <td>{this.props.actionPanel}</td>
        </tr>

      </tbody>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./components/conversations/MessageItem.jsx